import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { QuestionNumberButton } from '@doltech/ui/lib/figma/Question/QuestionNumberButton/QuestionNumberButton';
import { flexGap, horizontalSpace } from '@doltech/utils/lib/css-style';
import { useTestSubmissionStore } from '../../../model/test-submissions.hook';

interface QuestionBarProps extends React.HTMLAttributes<HTMLDivElement> {}

const Main = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  .question-group {
    .question-no-wrapper {
      display: flex;
      ${flexGap(8)}
      align-items: center;
    }
  }

  ${horizontalSpace(8)}
`;

export const PracticeTestQuestionBar = observer((_props: QuestionBarProps) => {
  const testSubmissionStore = useTestSubmissionStore();
  const testSection = testSubmissionStore.currentTestSection;
  if (!testSection) return null;
  return (
    <Main>
      {(testSection?.questionGroups || []).map((item, groupIndex) => {
        const { id, questions } = item;
        return (
          <div className="question-group" key={id}>
            <div className="question-no-wrapper">
              {questions.map((question) => {
                const { bottomBarQuestionNoes } = question;
                return bottomBarQuestionNoes?.map(({ no, answered }) => {
                  return (
                    <QuestionNumberButton
                      key={no}
                      type={answered ? 'answered' : 'default'}
                      size={'large'}
                      textNumber={no}
                      selected={false}
                      onClick={() => {
                        if (testSubmissionStore.preventUserAction()) return;
                        testSection.goToQuestion({
                          questionNo: no,
                          groupIndex,
                        });
                      }}
                    />
                  );
                });
              })}
            </div>
          </div>
        );
      })}
    </Main>
  );
});
